import { useState } from 'react';
import { vinScannerApi, VinDecodeResult } from '@/api/vinScanner';

export const useVinDecoder = () => {
  const [isDecoding, setIsDecoding] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const decodeVin = async (vin: string): Promise<VinDecodeResult | null> => {
    setIsDecoding(true);
    setError(null);

    try {
      const result = await vinScannerApi.decodeVin(vin);
      return result;
    } catch (err) {
      const errorMessage =
        err instanceof Error ? err.message : 'Failed to decode VIN';
      setError(errorMessage);
      return null;
    } finally {
      setIsDecoding(false);
    }
  };

  const clearError = () => {
    setError(null);
  };

  return {
    decodeVin,
    isDecoding,
    error,
    clearError,
  };
};
